export const mit_valid_email_extensions = [
    'mit.edu',
    'csail.mit.edu',
    'media.mit.edu',
    'math.mit.edu',
    'physics.mit.edu',
    'eecs.mit.edu',
    'architecture.mit.edu',
    'meche.mit.edu',
    'aeroastro.mit.edu',
    'biology.mit.edu',
    'chemistry.mit.edu',
    'linguistics.mit.edu',
    'libraries.mit.edu',
    'press.mit.edu',
    'alum.mit.edu',

    // Add more emails extensions here
];